import { useState, useEffect } from "react";
import { Package } from "lucide-react";
import { mediaUrl } from "@/lib/media";

export function ProductThumb({ path, alt, size = 44, className = "", rounded = true }) {
  const [err, setErr] = useState(false);
  useEffect(() => { setErr(false); }, [path]);
  const url = path ? mediaUrl(path) : null;
  const box = `flex shrink-0 items-center justify-center overflow-hidden border border-slate-200 bg-slate-50 dark:border-slate-700 dark:bg-slate-800 ${rounded ? "rounded-md" : ""} ${className}`;
  const style = { width: size, height: size };
  if (!url || err) {
    return (
      <div className={box} style={style} data-testid="product-thumb-placeholder" aria-hidden="true">
        <Package className="text-slate-400" style={{ width: size * 0.5, height: size * 0.5 }} />
      </div>
    );
  }
  return (
    <div className={box} style={style}>
      <img src={url} alt={alt || ""} loading="lazy" onError={() => setErr(true)}
           data-testid="product-thumb"
           className="h-full w-full object-contain" />
    </div>
  );
}
